import { useMutation } from "@tanstack/react-query";
import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { apiFetch } from "@/lib/api-client";

interface BulkDeletePayload {
  projectUuid: string;
  label: "UserJourney" | "Flow" | "Page" | "Component";
  ids: string[];
}

async function bulkDeleteDesignOntology(
  payload: BulkDeletePayload,
  token: string
) {
  const url = `${config.isometricApiUrl}/design-ontology-graph/${payload.projectUuid}/bulk-delete`;

  const response = await apiFetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      label: payload.label,
      ids: payload.ids,
    }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error: any = new Error(
      errorData.message || "Bulk delete failed"
    );
    error.status = response.status;
    throw error;
  }

  return response.json();
}

export const useBulkDeleteDesignOntology = (
  onSettled?: (data: any, error: Error | null) => void
) => {
  const { getAuthHeaders } = useAuthHeaders();

  return useMutation({
    mutationFn: (payload: BulkDeletePayload) => {
      const headers = getAuthHeaders();
      const token = headers.Authorization.replace("Bearer ", "");
      return bulkDeleteDesignOntology(payload, token);
    },
    onSettled: (data, error) => {
      onSettled?.(data, error as Error | null);
    },
  });
};
